import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './styles.scss';

const FeatureOriginPill = ({ type }) => {
  const { t } = useTranslation();
  return (
    <div className={`FeatureOriginPill FeatureOriginPill-${type}`}>
      {type === 'license'
        ? t('License custom value')
        : t('Product default value')}
    </div>
  );
};

FeatureOriginPill.propTypes = {
  type: PropTypes.oneOf(['license', 'product']).isRequired,
};

export default FeatureOriginPill;
